class VerticalSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.prevButton = this.querySelectorAll('button[name="previous"]');
    this.nextButton = this.querySelectorAll('button[name="next"]');

    this.totalSlides = this.sliderItems.length;
    
    if (this.totalSlides <= 1) return;
    
    this.slideTransform = 20;
    if (this.totalSlides === 2 || this.totalSlides === 3) {
      this.slideTransform = 40;
    } else if (this.totalSlides === 4) {
      this.slideTransform = 30;
    }

    this.classes = Array.from(this.sliderItems).map((_, index) => `slider__slide-${index + 1}`);

    this.windowWidth = window.innerWidth;

    this.updateBoxes = this.updateBoxes.bind(this);
    this.cycleNext = this.cycleNext.bind(this);
    this.cyclePrev = this.cyclePrev.bind(this);
    this.onResize = this.debounce(this.onResize.bind(this), 200);

    this.prevButton.forEach(button => button.addEventListener('click', this.cyclePrev));
    this.nextButton.forEach(button => button.addEventListener('click', this.cycleNext));

    window.addEventListener('resize', this.onResize);

    setTimeout(() => this.setupVerticalSlider(), 100);
    this.updateBoxes();
  }

  setupVerticalSlider() {
    this.slider.style.height = 'auto';
    this.sliderItems.forEach((slide) => {
      slide.style.height = 'auto';
    });

    setTimeout(() => {
      const heights = Array.from(this.sliderItems, slide => slide.offsetHeight);
      const maxHeight = Math.max(...heights);

      this.slider.style.height = `${maxHeight + this.slideTransform * (this.totalSlides - 1)}px`;

      this.sliderItems.forEach((slide) => {
        slide.style.height = `${maxHeight}px`;
      });
    }, 50);
  }

  updateBoxes() {
    this.sliderItems.forEach((box, index) => {
      box.className = 'vertical-slider__slide ' + this.classes[index];
    });
  }

  cycleNext() {
    const boxAnimate = this.querySelector(`.slider__slide-${this.totalSlides}`);
    boxAnimate.classList.add('moving');

    setTimeout(() => {
      const firstClass = this.classes.shift();
      this.classes.push(firstClass);

      this.updateBoxes();

      boxAnimate.classList.remove('moving');
    }, 400);
  }

  cyclePrev() {
    const boxAnimate = this.querySelector(`.slider__slide-${this.totalSlides}`);
    boxAnimate.classList.add('moving');

    setTimeout(() => {
      const lastClass = this.classes.pop();
      this.classes.unshift(lastClass);

      this.updateBoxes();

      boxAnimate.classList.remove('moving');
    }, 400);
  }

  onResize() {
    const newWidth = window.innerWidth;
    if (Math.abs(this.windowWidth - newWidth) > 5) {
      this.windowWidth = newWidth;
      this.setupVerticalSlider();
    }
  }

  debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }
}

customElements.define('vertical-slider-component', VerticalSliderComponent);
